module.exports = "/_next/static/images/phone-note-1-2x-228bfe92b9fdc7d5dd3d618be640ec37.png.webp";